import { UserPreference } from '../classes/user-preference';
import { LoginResponse } from './login-response';

export class LoginUserResponse {
    authInfo: LoginResponse;
    userInfo: LoggedInUserDto;
}

export class LoggedInUserDto {
    userId: string;
    azureId: string;
    firstName: string;
    lastName: string;
    middleName: string;
    email: string;
    status: string;
    type: string;
    puid: string;
    title: string;
    workPhone: string;
    countryCode: string;
    linkedAccounts: LinkedAccounts[];
    businessUnits: BusinessUnitDto[];
    userPreferences: UserPreference[];
    isMfaEnabled: boolean;
}

export class LinkedAccounts {
    accountCode: string;
    linkedAccountId: string;
    linkedAccountName: string;
    isDeleted: boolean;
    billingMethod: string;
    status: string;
    addressDetailsDto: AddressDetailsDto;
    authorizingAccountDtos: AuthorizingAccounts[];
}

export class AddressDetailsDto {
    contactPerson: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    zipCode: string;
    country: string;
    phone: string;
    emails: string;
    faxNumbers: string;
    stateCode: string;
    stateName: string;
}

export class BusinessUnitDto {
    buId: string;
    buCode: string;
    buName: string;
    isDeleted: boolean;
    buTypes: string;
    buPermissions: string;
    receivingLabAddress: string;
    disclaimerText: string;
}

export class AuthorizingAccounts {
    linkedAccountId: string;
    accountCode: string;
    linkedAccountName: string;
    status: string;
}

export class LoggedInUserLABUDto {
    linkedAccounts: LinkedAccounts[];
    userPreferences: UserPreference[];
}


